export enum UUIDTypes {
  PatientUuidType = 3,
  careTaskUuidType = 6,
}
